import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Table, Layout, Row, Col, Button, Tag, Input, Divider} from 'antd'
import { Sidebar } from '../../../components'
import { logoutUser } from '../../../actions/authActions'
import {LoadingOutlined, SearchOutlined} from "@ant-design/icons";
import {
  fetchCustomerArchivedOrders
} from "../../../actions/ordersActions";
import format from "date-fns/format";
import {formatTableDate, getColumnSearchProps} from "../../../utils/utility";
import history from "../../../utils/history";

export const CustomerCompletedPage = (props) => {
  let searchInput = null;

  const user = useSelector(state => state.auth.user);
  const isFetchingArchivedOrders = useSelector(state => state.orders.isFetchingCustomerArchivedOrders)
  const archivedOrders = useSelector(state => state.orders.customerArchivedOrders)
  const pagination = useSelector(state => state.orders.customerAcceptedOrdersPagination)
  const isCollapsed = useSelector(state => state.util.isCollapsed);
  const dispatch = useDispatch()

  const getPageSize = () => {
    const count = Math.floor((window.innerHeight - 150) / 50)
    return count > 10 ? count : 10;
  }

  const pageSize = getPageSize();

  useEffect(() => {
    dispatch(fetchCustomerArchivedOrders({
      sortField: "completionDate",
      sortDirection: "desc",
      orderName: "",
      state: "",
      page: pagination.current !== undefined ? pagination.current : 1,
      pagination: {...pagination, pageSize: pageSize}
    }))
  }, [])

  const handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...pagination };
    pager.current = pagination.current

    const sortField = sorter.order ? sorter.columnKey : "completionDate"
    const sortDirection = sorter.order ? (sorter.order === "ascend" ? "asc" : "desc") : "desc"
    const orderName = filters.orderName ? filters.orderName[0] : ""
    const state = filters.state && filters.state.length === 1 ? filters.state[0] : ""

    dispatch(fetchCustomerArchivedOrders({
      sortField: sortField,
      sortDirection: sortDirection,
      orderName: orderName,
      page: pagination.current,
      pagination: pager,
      state: state
    }))
  }

  return (
    <Layout
      style={{
        overflow: 'auto',
        minHeight: '100vh',
      }}
    >
      <Sidebar
        onLogout={()=>{dispatch(logoutUser())}}
        user={user}
      />
      <Layout.Content style={{marginLeft: isCollapsed ? 60 : 200, transition: "all 0.25s"}}>
        <div style={{marginRight: 25, marginBottom: 15, marginLeft: 25, marginTop: 15}}>
          <Row>
            <Col span={24}>
              <div style={{ height: 32, display: "flex", alignItems: "center" }}>
                <div style={{fontWeight: 500, fontSize: 16}}>These are your completed orders:</div>
              </div>
              <Divider style={{marginTop: 6, marginBottom: 11}}/>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={24}>
              <React.Fragment>
                <Table
                  columns={[
                    {
                      title: 'Order Code',
                      key: 'orderName',
                      className: "darkerColumn",
                      width: "15%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {row.orderName}
                        </div>
                      ),
                      ...getColumnSearchProps('code', searchInput),
                    },
                    {
                      title: 'Custom Order Name',
                      key: 'customName',
                      width: "15%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {row.customName || "-"}
                        </div>
                      ),
                    },
                    {
                      title: 'Order date',
                      key: 'orderDate',
                      className: "darkerColumn",
                      width: "11%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {formatTableDate(row.orderDate)}
                        </div>
                      ),
                      sorter: true,
                    },
                    {
                      title: 'Delivery date',
                      key: 'deliveryDate',
                      width: "11%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {formatTableDate(row.deliveryDate)}
                        </div>
                      ),
                      sorter: true,
                    },
                    {
                      title: 'Total with VAT',
                      key: 'totalWithVat',
                      className: "darkerColumn",
                      align: "right",
                      width: "10%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {(row.totalPrice * (1 + row.vatValue) || row.totalPrice || 0).toFixed(2)}€
                        </div>
                      ),
                    },
                    {
                      title: 'Completion Date',
                      key: 'completionDate',
                      align: "right",
                      width: "13%",
                      render: row => (
                        <div style={{fontWeight: 500, fontSize: 13}}>
                          {formatTableDate(row.completionDate)}
                        </div>
                      ),
                      sorter: true,
                    },
                    {
                      title: 'Status',
                      key: 'state',
                      className: "darkerColumn",
                      align: "center",
                      width: "15%",
                      render: row => (
                        <div>
                          <React.Fragment>
                            {row.state === "completed" ?
                              <Tag color="#1c84e0" style={{fontWeight: 600, textAlign: "center", width: 89}}>Completed</Tag>
                              :
                              <Tag color="#cc332c" style={{fontWeight: 600, textAlign: "center", width: 89}}>Declined</Tag>
                            }
                          </React.Fragment>
                        </div>
                      ),
                      filters: [{
                        text: 'Declined',
                        value: 'declined',
                      }, {
                        text: 'Completed',
                        value: 'completed',
                      }],
                    },
                    {
                      title: '',
                      key: 'more',
                      align: "right",
                      render: row => (
                        <Button
                          onMouseDown={(e) => {
                            if (e.button === 1) {
                              const win = window.open(`/completed-order?order=${row.id}`, "_blank");
                              win.focus();
                            } else if (e.button === 0) {
                              history.push(`/completed-order?order=${row.id}`)
                            }
                          }}
                          type="primary"
                          style={{
                            fontSize: 13,
                            fontWeight: 600
                          }}
                        >
                          Details
                        </Button>
                      ),
                    },
                  ]}
                  className={"pendingOrdersTable"}
                  dataSource={archivedOrders}
                  rowKey="id"
                  pagination={{...pagination, pageSize: pageSize}}
                  loading={{spinning: isFetchingArchivedOrders, indicator: <LoadingOutlined style={{ fontSize: 50,marginLeft: "-25px" }} spin />}}
                  onChange={handleTableChange}
                  size={"small"}
                  scroll={{x: '70%'}}
                />
              </React.Fragment>
            </Col>
          </Row>
        </div>
      </Layout.Content>
    </Layout>
  )
}
